import { Separator } from '../../../../../primitives/separator';
import { EditorPlain } from '../../../../editor/components/editor-plain';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { Alignment } from '../controls/alignment';
import { Spacing } from '../controls/spacing';
import { Appearance } from './appearance';

import type { AvatarEditorContentProps } from './types';

export type { AvatarEditorStyleUpdates } from './types';

export function AvatarEditorContent({
  altText,
  horizontalAlignment,
  imageUrl,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  shape,
  size,
  onAltTextChange,
  onImageUrlChange,
  onShapeChange,
  onSizeChange,
  onStyleChange,
}: AvatarEditorContentProps) {
  return (
    <div className="grid gap-4">
      <div className="space-y-2">
        <p className="text-xs font-medium">Contenido</p>
        <div className="grid gap-y-1">
          <div>
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              URL de imagen
            </LabelWithoutRef>
            <EditorPlain
              id="content-avatar-source-url"
              type="input"
              value={imageUrl}
              onChange={(value) => onImageUrlChange(value)}
            />
          </div>
          <div>
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Texto descriptivo de imagen
            </LabelWithoutRef>
            <EditorPlain
              counter={{ enable: true }}
              id="content-avatar-alt-text"
              type="input"
              value={altText}
              onChange={(value) => onAltTextChange(value)}
            />
          </div>
        </div>
      </div>

      <Separator />

      <Appearance
        shape={shape}
        size={size}
        onSizeChange={onSizeChange}
        onShapeChange={onShapeChange}
      />

      <Separator />

      <Alignment
        isHorizontalAlignmentVisible
        horizontalAlignment={horizontalAlignment}
        onHorizontalAlignmentChange={(newAlignment) => onStyleChange({ textAlign: newAlignment })}
      />

      <Separator />

      <Spacing
        margin={margin}
        onChangeMargin={(margin) => onStyleChange({ margin })}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        isPaddingVisible
        onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
        onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
        onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
        onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
      />
    </div>
  );
}
